import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { WorkflowScheduleData, WorkflowScheduleResponse } from "../types/workflowSchedules.type";

const useMaintenanceWorkflowSchedule: (id: string) => UseQueryResult<WorkflowScheduleData, unknown> = (id) => {
  const privateAxios = usePrivateAxios();

  return useQuery<WorkflowScheduleResponse, unknown, WorkflowScheduleData>({
    queryKey: ['maintenanceWorkflowSchedule', id],
    queryFn: () => privateAxios.get(`/maintenance/workflow_schedules/${id}`),
    select: (data) => data?.data?.data
  });
};

export default useMaintenanceWorkflowSchedule;
